import Tree from 'components/common/Tree/Tree';

function TreeExample(): JSX.Element {
  const root1 = {
    key: '',
    children: [
      {
        key: 'Pets',
        children: [
          {
            key: 'Cats',
            children: [
              { key: 'Abyssinian', value: 'Fluffy' },
              { key: 'Calico', value: 'Socks' },
              { key: 'Siamese', value: 'Bumble' },
            ],
          },
          { key: 'Fish', value: 'Swimmy' },
          {
            key: 'Dogs',
            children: [
              { key: 'Chug', value: 'Penny' },
              { key: 'Mutt', value: 'Smoky' },
              { key: 'Chiweenie', value: 'Lulu' },
            ],
          },
          { key: 'Marsupial', value: 'Bitey the Opossum' },
        ],
      },
      {
        key: 'To-do',
        children: [
          { key: 'arts', value: 'write a story' },
          { key: 'leisure', value: 'snorkel' },
          { key: 'optimism', value: 'cultivate my garden' },
        ],
      },
    ],
  };

  return (
    <section id="tree" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Tree</h1>
      <div className="ExamplesPage__Description">
        A tree presents a hierarchical view of key/value pairs, where each non-root node has a key and either a value or
        children.
      </div>
      <Tree root={root1}></Tree>
    </section>
  );
}

export default TreeExample;
